import renderGenericMultipleSelectForm from './renderGenericMultipleSelectForm'

export default renderGenericMultipleSelectForm
